// Typescript metadata
import 'reflect-metadata';

import * as React from 'react';
import {render} from 'react-dom';
import {container} from './services/container';
import {Facebook} from './services/facebook';
import {Server} from './services/server';
import {Translate} from './services/translate';
import Modal from 'react-modal';
import {App} from "./components/app";

// Container setup
container.bind(Facebook).toSelf();
container.bind(Server).toSelf();
container.bind(Translate).toSelf();

// container.get(Facebook); // Initialize facebook

const appElement = document.createElement('div');

// Specify for react-modal
Modal.setAppElement(appElement);

render(<App />, document.body.appendChild(appElement));